import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState('');
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  // Assurez-vous que ReCAPTCHA est bien initialisé lors du montage
  useEffect(() => {
    setRecaptchaValue(null); // Force le réinitialisation du reCAPTCHA à chaque fois que la page est rechargée
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!recaptchaValue) {
      setStatus('Veuillez valider le reCAPTCHA.');
      return;
    }

    // Effectuer les validations supplémentaires ici

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
      to_email: 'secretariat@lesvf.com',
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(() => {
        setStatus('Merci pour votre message ! Nous vous répondrons bientôt.');
        setFormData({ name: '', email: '', message: '' });
        setRecaptchaValue(null); // Réinitialisation du reCAPTCHA
      })
      .catch((error) => {
        setStatus("Une erreur s'est produite, veuillez réessayer.");
        console.error('Erreur lors de l\'envoi :', error);
      });
  };

  return (
    <div className="contact-form">
      <h2 className="contact-title">Contactez-nous</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="name">Nom:</label>
          <input
            type="text"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="message">Message:</label>
          <textarea
            id="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        {/* reCAPTCHA */}
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} // Clé publique
          onChange={(value) => setRecaptchaValue(value)}
        />

        <button type="submit">Envoyer</button>
      </form>
      {status && <p className="status-message">{status}</p>}
    </div>
  );
};

export default ContactForm;
